import React from "react";

/**
 * 포토 프레임 상세정보 모달 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {boolean} props.isVisible - 모달 표시 여부
 * @param {Object} props.photoFrame - 포토 프레임 정보
 * @param {Function} props.onClose - 모달 닫기 함수
 */
const PhotoFrameDetailModal = ({
    isVisible,
    photoFrame,
    onClose,
}) => {
    if (!isVisible || !photoFrame) return null;

    // 날짜 포맷팅 헬퍼
    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '무제한';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}${month}${day}`;
    };

    return (
        <div className="modal-overlay active" id="frame-detail-modal">
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">프레임 상세정보</h3>
                    <button className="modal-close" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="detail-item-container">
                        <span className="detail-label">프레임명</span>
                        <span className="detail-content">{photoFrame.frameName}</span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">프레임 설명</span>
                        <span className="detail-content">
                            {photoFrame.frameDescription || '없음'}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">타입</span>
                        <span className="detail-content">
                            {photoFrame.frameType || '없음'}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">방향</span>
                        <span className="detail-content">
                            {photoFrame.orientation || '없음'}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">사용 기간</span>
                        <span className="detail-content">
                            {formatDateForDisplay(photoFrame.startDatetime)} - {formatDateForDisplay(photoFrame.endDatetime)}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">사용 지점</span>
                        <span className="detail-content">
                            {photoFrame.branches && photoFrame.branches.length > 0
                                ? photoFrame.branches.map(b => b.branchName).join(', ')
                                : '없음'}
                        </span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">배포 여부</span>
                        <span className="detail-content">
                            {photoFrame.isDeployed ? 'Y' : 'N'}
                        </span>
                    </div>
                    
                    {/* 공통 리소스 시스템 */}
                    {photoFrame.frameDataResourceId && (
                        <div className="detail-item-container">
                            <span className="detail-label">리소스 ID</span>
                            <span className="detail-content">{photoFrame.frameDataResourceId}</span>
                        </div>
                    )}
                    
                    {/* 기존 파일 정보 (호환성) */}
                    <div className="detail-item-container">
                        <span className="detail-label">파일명</span>
                        <span className="detail-content">
                            {photoFrame.originalFilename || '없음'}
                        </span>
                    </div>
                    
                    {photoFrame.fileSize && (
                        <div className="detail-item-container">
                            <span className="detail-label">파일 크기</span>
                            <span className="detail-content">
                                {(photoFrame.fileSize / 1024 / 1024).toFixed(2)} MB
                            </span>
                        </div>
                    )}
                    
                    <div className="detail-item-container">
                        <span className="detail-label">작성자</span>
                        <span className="detail-content">{photoFrame.createdBy}</span>
                    </div>
                    
                    <div className="detail-item-container">
                        <span className="detail-label">생성일시</span>
                        <span className="detail-content">
                            {photoFrame.createdAt 
                                ? new Date(photoFrame.createdAt).toLocaleString('ko-KR') 
                                : '-'}
                        </span>
                    </div>
                    
                    {photoFrame.updatedAt && (
                        <div className="detail-item-container">
                            <span className="detail-label">수정일시</span>
                            <span className="detail-content">
                                {new Date(photoFrame.updatedAt).toLocaleString('ko-KR')}
                            </span>
                        </div>
                    )}
                    
                    {photoFrame.updatedBy && (
                        <div className="detail-item-container">
                            <span className="detail-label">수정자</span>
                            <span className="detail-content">{photoFrame.updatedBy}</span>
                        </div>
                    )}
                </div>
                <div className="modal-footer">
                    <button 
                        className="modal-btn modal-btn-primary" 
                        onClick={onClose}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PhotoFrameDetailModal;
